export enum subjectsTypeEnum {
    INTERNO_EXTERNO = 1,
    EXTERNO = 2,
    INTERNO = 3
}